import React from 'react';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { setLoadableErrorAttributes } from '@confluence/monitoring/entry-points/error-attributes.ts';

export function createElementWithCheckForInvalidType(
	type: any,
	rest: any,
	name: string | undefined,
): React.ReactNode {
	// https://github.com/facebook/react/blob/8f8b336734d7c807f5aa11b0f31540e63302d789/packages/react-reconciler/src/ReactFiber.js#L557
	const validType =
		// Functional or class component
		typeof type === 'function' ||
		// built-in HTML elements
		typeof type === 'string' ||
		// react special types like fragments
		typeof type === 'symbol' ||
		// other special types like context and memo
		(typeof type === 'object' && type !== null && type.$$typeof);

	if (!validType) {
		let serialized: string = typeof type;
		try {
			if (serialized === 'object') {
				if (type instanceof Event) {
					if ((type as any).message) {
						const errorEvent = type as ErrorEvent;
						serialized = `ErrorEvent: ${errorEvent.message} ${errorEvent.filename}@${errorEvent.lineno || ''}:${errorEvent.colno || ''} ${errorEvent.error}`;
					} else {
						serialized = `Event: ${type.type} - ${JSON.stringify(type)}`;
					}
				} else {
					serialized = JSON.stringify(type);
				}
			}
		} catch (e) {
			serialized = `Error serializing ${typeof type}: ${e.message}`;
		}

		const error = new Error(`Invalid loadable createElement type: ${serialized}`);
		setLoadableErrorAttributes(error, { name });
		getMonitoringClient().submitError(error, {
			attribution: 'backbone-loadable',
		});
	}
	return React.createElement(type, rest);
}
